import { useCallback } from "react";
import {
  useDisableRole,
  useEnableRole,
} from "../mutations/useStatusRoleToggle.mutation";

export const useRoleStatusToggle = () => {
  const disableMutation = useDisableRole();
  const enableMutation = useEnableRole();

  const handleEnable = useCallback(
    (id: string) => {
      enableMutation.mutate(id);
    },
    [enableMutation],
  );

  const handleDisable = useCallback(
    (id: string) => {
      disableMutation.mutate(id);
    },
    [disableMutation],
  );

  return {
    handleDisable,
    isDisabling: disableMutation.isPending,
    handleEnable,
    isEnabling: enableMutation.isPending,
  };
};
